import { Box } from '@mui/material'
import { RequesterEmailValidationProps } from './props'
import { SingleCenteredCardLayout } from '../../../layouts/SingleCenteredCardLayout/SingleCenteredCardLayout'
import { VARIANTS, VariantContent } from './VariantContent'
import { LogotypeIcon } from '../../../assets/icons/icons'
import { sxs } from './style'

export const RequesterEmailValidationDisplay = ({ variant }: RequesterEmailValidationProps) => (
    <SingleCenteredCardLayout>
        <LogotypeIcon title="toktokdoc" style={{ width: '11rem', height: 'auto' }} />
        <Box sx={sxs.content}>
            <VariantContent {...VARIANTS[variant]} />
        </Box>
    </SingleCenteredCardLayout>
)
